<label *ngIf="props.label" class="field-label" [attr.for]="id">{{ props.label }}</label>

<ng-container #fieldComponent />

<p *ngIf="field.formControl?.touched && field.formControl?.errors" class="field-error">
  <formly-validation-message [field]="field" />
</p>
